import React from 'react';

import { Box, Button, SvgIcon } from '@mui/material';

import API from 'app/API';
import IconEmail from 'app/ui-kit/icons/Download.svg';
import CnaCvss from 'pages/item/v2/components/Score/components/CnaCvss';
import Cvss from 'pages/item/v2/components/Score/components/Cvss';
import Ssvc from 'pages/item/v2/components/Score/components/Ssvc';

import Ai from './components/Ai';
import Epss from './components/Epss';
import useStyles from './styles';

interface CvssValue {
    version: string;
    baseScore: number;
    vectorString: string;
    [key: string]: string | number | boolean;
}

interface CnaCvssValue {
    score: number;
    vector: string;
}

interface SsvcValue {
    id: string;
    role: string;
    options: Record<string, string>[];
}

interface Props {
    id: string;
    metrics?: {
        cvss2?: CvssValue;
        cvss3?: CvssValue;
        cvss4?: CvssValue;
        ssvc?: SsvcValue;
    };
    cnaCvss?: {
        cvss?: {
            ['2']?: CnaCvssValue;
            ['3']?: CnaCvssValue;
            ['4']?: CnaCvssValue;
        };
    };
    epss?: { epss: number; percentile: number }[];
    aiScore?: { value: number; uncertanity: number };
    showSource?: boolean;
}

const Score: React.FC<Props> = ({ metrics, cnaCvss, aiScore, id, epss, showSource = true }) => {
    const { classes } = useStyles();

    return (
        <>
            {metrics?.cvss2 ? (
                <Cvss data={metrics?.cvss2} />
            ) : cnaCvss?.cvss?.['2'] ? (
                <CnaCvss data={cnaCvss.cvss['2']} version={2} />
            ) : null}
            {metrics?.cvss3 ? (
                <Cvss data={metrics?.cvss3} />
            ) : cnaCvss?.cvss?.['3'] ? (
                <CnaCvss data={cnaCvss.cvss['3']} version={3} />
            ) : null}
            {metrics?.cvss4 ? (
                <Cvss data={metrics?.cvss4} />
            ) : cnaCvss?.cvss?.['4'] ? (
                <CnaCvss data={cnaCvss.cvss['4']} version={4} />
            ) : null}
            {aiScore ? <Ai aiScore={aiScore} /> : null}
            {epss ? <Epss epss={epss} /> : null}
            {metrics?.ssvc ? <Ssvc ssvc={metrics.ssvc} /> : null}
            {showSource ? (
                <Box display="flex" justifyContent="flex-start">
                    <Button
                        fullWidth
                        className={classes.json}
                        variant="outlined"
                        href={`${API.SEARCH_ID.url}?id=${id}`}
                        target="_blank"
                        rel={'nofollow'}
                        startIcon={<SvgIcon component={IconEmail} />}
                    >
                        {'JSON'}
                    </Button>
                </Box>
            ) : null}
        </>
    );
};

export default Score;
